import { styled } from 'linaria/react';

export const HeaderContainer = styled.div`
  width: 100%;
`;

export const FooterLayoutContainer = styled.div`
  width: 100%;
  margin-top: auto;
`;
